export default {
  notificationState: {
    show: false,
    duration: null,
    type: null,
    message: null,
    content: null
  }
};
